import { render, staticRenderFns } from "./BusinessMedicationDeleteConfirmationModal.vue?vue&type=template&id=297cd8b6"
import script from "./BusinessMedicationDeleteConfirmationModal.vue?vue&type=script&lang=js"
export * from "./BusinessMedicationDeleteConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports